import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "recompact"
import { TabsWithReactRouter } from "@infotech/uikit-tabs"
import { Route, Switch } from "react-router-dom"
import { Box } from "@infotech/uikit-grid"
import { CloseIcon } from "@infotech/uikit-icons"
import { selectValue } from "src/engine/modules/ui/selectors"
import queryString from "query-string"
import ModalConfirm from "src/components/modals/ModalConfirm"
import noop from "lodash/noop"
import withSideModalPending from "src/hocs/withSideModalPending"
import { P } from "@infotech/uikit-text"
import styles from "./styles.css"

const replacePath = (path, id) =>
  path.to
    .replace(`:id`, id)
    .replace(`:planId`, id)
    .replace(`:date`, path.date)
    .replace(`:scale`, path.scale)

const TabsComponent = withSideModalPending(
  `data`,
  `Не найдено`,
  true,
)(({ tabs, basicUrl, closeUrl, dataForTabs, id }) => {
  const tabsWithPath = tabs.map(item => ({
    ...item,
    to: `${replacePath(item, id)}${item.search || ``}`,
  }))
  return (
    <Box loose>
      <TabsWithReactRouter items={tabsWithPath} />
      <div>
        <Switch>
          {tabs.map(item => {
            const Item = item.component
            return (
              <Route
                // exact
                path={replacePath(item, id)}
              >
                <Box loose className={styles.TabWrapper}>
                  <Item
                    basicUrl={basicUrl}
                    closeUrl={closeUrl}
                    id={id}
                    dataForTabs={dataForTabs || {}}
                  />
                </Box>
              </Route>
            )
          })}
        </Switch>
      </div>
    </Box>
  )
})

const TabsCrudModal = props => {
  const {
    paramsId,
    dirty,
    history,
    queryParams,
    tabConfig,
    dataForTabs,
    areMenuCaptionsVisible,
  } = props
  const { basicUrl, closeUrl, tabs, createTitle, editTitle } = tabConfig

  const [isConfirmationModalOpen, toggleConfirmationModal] = useState(false)
  const closeModal = () => {
    history.push(
      `${closeUrl || basicUrl}?${queryString.stringify(queryParams)}`,
    )
  }

  return (
    <Box
      loose
      className={styles.TabsModalWrapper}
      style={{ left: areMenuCaptionsVisible ? `259px` : `56px` }}
    >
      <Box loose flex className={styles.TabsModalHeader}>
        <Box loose pt="2md" pl="2md" className={styles.TabsModalTitle}>
          {paramsId === `new` ? createTitle : editTitle}
        </Box>
        <Box
          loose
          className={styles.CloseModalIcon}
          onClick={() =>
            dirty
              ? toggleConfirmationModal(!isConfirmationModalOpen)
              : closeModal()
          }
        >
          <div data-testid="close-entity-tabs-modal-icon">
            <CloseIcon />
          </div>
        </Box>
      </Box>
      <TabsComponent
        tabs={tabs}
        basicUrl={basicUrl}
        closeUrl={closeUrl}
        dataForTabs={dataForTabs}
        data={Object.values(dataForTabs || {})[0]}
        id={paramsId}
        allProps={props}
      />

      <ModalConfirm
        isOpen={isConfirmationModalOpen}
        title="Закрыть без сохранения?"
        buttonConf={[
          {
            text: `Закрыть`,
            onClick: dirty ? closeModal : noop,
            isOk: true,
            done: true,
            disabled: false,
          },
          {
            text: `Отмена`,
            onClick: () => toggleConfirmationModal(!isConfirmationModalOpen),
            disabled: false,
          },
        ]}
        isClose
      >
        <div className={styles[`modal-message-wrapper`]}>
          <P className={styles[`modal-message-text`]}>
            Все сделанные вами изменения будут утеряны
          </P>
        </div>
      </ModalConfirm>
    </Box>
  )
}

TabsCrudModal.propTypes = {
  paramsId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  dirty: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  history: PropTypes.shape({
    location: PropTypes.object,
  }).isRequired,
  queryParams: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  tabConfig: PropTypes.shape({
    basicURL: PropTypes.string,
    tabs: PropTypes.array,
  }).isRequired,
  areMenuCaptionsVisible: PropTypes.bool.isRequired,
  createTitle: PropTypes.string,
  editTitle: PropTypes.string,
}

TabsCrudModal.defaultProps = {
  dirty: 0,
  queryParams: {},
  createTitle: null,
  editTitle: null,
}

export default compose(
  connect(
    state => ({
      areMenuCaptionsVisible: selectValue(state, `areMenuCaptionsVisible`),
    }),
    null,
  ),
)(TabsCrudModal)
